import en from "./en/translation.json";
import tw from "./zh-TW/translation.json";

const resources = {
  en: {
    translation: en,
  },
  "zh-TW": {
    translation: tw,
  },
};

export default resources;
